// Module
var code = "<div> <div class=\"pull-right\"> <div class=\"btn-group\"> <div class=\"btn btn-secondary game-config-btn\" ng-click=\"addRow()\"> <i class=\"glyphicon glyphicon-copy\"></i> </div> <div class=\"btn btn-danger game-config-btn\" ng-click=\"deleteRow()\"> <i class=\"glyphicon glyphicon-remove\"></i> </div> </div> </div> </div>";
// Exports
var _module_exports = code;;
var path = 'machines/laguna/Pages/Edit/formly/copyDelete.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;